// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2GHPC","resendInfoText":"OnGoingPaymentBox_resendInfoText__2O87q"};